import { v4 as uuidv4} from 'uuid';

const USER_INFO_SESSION_KEY = 'user_info_session';
const SESSION_BROWSER_ID = 'session_browser_id';

//base utils
function setItem(key, value) {
    sessionStorage.setItem(key, value);
}

function getItem(key) {
    const value = sessionStorage.getItem(key);
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}

function deleteItem(key) {
    sessionStorage.removeItem(key);
}

function getUserInfoSession(){
    return getItem(USER_INFO_SESSION_KEY);
}
function deleteUserInfoSession(){
    deleteItem(USER_INFO_SESSION_KEY)
}

function setSessionBrowserId() {
    const sessionId = `solutiondesk_${uuidv4()}`
    setItem(SESSION_BROWSER_ID, sessionId);
    return sessionId;
}

function getSessionBrowserId(){
    let sessionBrowserId = getItem(SESSION_BROWSER_ID);
    if (!sessionBrowserId) {
        sessionBrowserId = setSessionBrowserId();
    }
    return sessionBrowserId;
}

function deleteSessionBrowserId(){
    deleteItem(SESSION_BROWSER_ID)
}

const sessionStorageUtil = {
    getUserInfoSession,
    deleteUserInfoSession,
    setSessionBrowserId,
    getSessionBrowserId,
    deleteSessionBrowserId,
}

export default sessionStorageUtil;

